export const INITIAL_SUPPORT = "初回支援"